module.exports = __webpack_public_path__ + "static/image/company/m/visual.ver2_0_2.jpg?6341fe62";